import { render } from "./DonateNowView.vue?vue&type=template&id=016a96f6"
import script from "./DonateNowView.vue?vue&type=script&lang=js"
export * from "./DonateNowView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__